/** Root path of the ask lumapps backoffice section  */
export const ASK_LUMAPPS_ADMIN_ROOT_PATH = '/admin/ai-search';

/** Available paths for the ask lumapps backoffice section */
export const ASK_LUMAPPS_ADMIN_PATHS = {
    sources: 'sources',
    rules: 'rules',
    expression: 'expressions',
} as const;
